// extracted by mini-css-extract-plugin
export default {"header":"Contabilidad_header__ebYBL","mes":"Contabilidad_mes__xJWVw"};